var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',{staticClass:"phone"},[_c('iframe',{staticClass:"demo-page",attrs:{"src":_vm.previewUrl,"frameborder":"0"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }